const opzioniTipologia = [
  {
    value: "tutte",
    label: "Tutte le tipologie",
    categorie: [
      "tutti-gli-immobili",
      "case-appartamenti",
      "garage",
      "locali-commerciali",
      "terreni",
      "capannoni",
      "magazzini",
      "palazzi-edifici",
      "altro",
    ],
  },
  { value: "villa", label: "Villa", categorie: ["case-appartamenti"] },
  {
    value: "appartamento",
    label: "Appartamento",
    categorie: ["case-appartamenti"],
  },
  {
    value: "attico",
    label: "Attico - Mansarda",
    categorie: ["case-appartamenti"],
  },
  {
    value: "indipendente",
    label: "Casa indipendente",
    categorie: ["case-appartamenti"],
  },
  {
    value: "villetta",
    label: "Villetta a schiera",
    categorie: ["case-appartamenti"],
  },
  { value: "altro", label: "Altro", categorie: ["case-appartamenti"] },
  {
    value: "terreno-edificabile",
    label: "Terreno edificabile",
    categorie: ["terreni"],
  },
  {
    value: "terreno-agricolo",
    label: "Terreno agricolo",
    categorie: ["terreni"],
  },
  {
    value: "posto-auto",
    label: "Posto auto",
    categorie: ["garage"],
  },
];

document.addEventListener("DOMContentLoaded", function () {
  if (document.getElementById("categoria")) {
    const categoria = document.getElementById("categoria");

    categoria.addEventListener("change", aggiornaTipologie);

    // Inizializza al load
    aggiornaTipologie();
  }
});

function aggiornaTipologie() {
  const catSelezionata = categoria.value;
  const tipologia = document.getElementById("tipologia");

  // Leggo il valore tipologia dalla url (se presente)
  const params = new URLSearchParams(window.location.search);
  const tipologiaFromURL = params.get("tipologia");
  tipologia.innerHTML = "";

  // Inserisci solo le opzioni compatibili
  opzioniTipologia.forEach((opt) => {
    if (opt.categorie.includes(catSelezionata)) {
      const option = document.createElement("option");
      option.value = opt.value;
      option.textContent = opt.label;
      if (opt.value === tipologiaFromURL) {
        option.selected = true;
      }
      tipologia.appendChild(option);
    }
  });
}
